import { isNil } from 'lodash-es';

export function isPresent<T>(value: T | '' | null | undefined): value is T {
	return !isNil(value) && value !== '';
}
